import React from 'react';
import './Testimonials.css';

const reviews = [
  {
    name: "Ramesh Sharma",
    city: "Patna",
    text: "Extremely professional service! The team arrived on time and packed all our fragile glass items and heavy furniture with great care. Highly recommended for shifting.",
    initials: "RS"
  },
  {
    name: "Anjali Sinha",
    city: "Gaya",
    text: "I relocated my house from Gaya to Delhi. Neha Packers & Movers did an amazing job. The delivery was right on time and there was absolutely zero damage to our goods.",
    initials: "AS"
  },
  {
    name: "Rajesh Kumar",
    city: "Ranchi",
    text: "Shifted my corporate office setup with them. Very efficient packing of office electronics and furniture. Minimal downtime for our business. Outstanding logistics support!",
    initials: "RK"
  },
  {
    name: "Sunita Gupta",
    city: "Delhi",
    text: "Very affordable rates and excellent support. The workers were very courteous, fast, and took special precautions for loading in narrow apartment stairways.",
    initials: "SG"
  }
];

export function Testimonials() {
  return (
    <section className="testimonials-section fade-up-element">
      <div className="container">
        <h2 className="section-title">Happy Clients</h2>
        <h3 className="section-subtitle">What Our Customers Say About Us</h3>
        <div className="testimonials-grid">
          {reviews.map((review, index) => (
            <div className="testimonial-card" key={index}>
              <div className="testimonial-header">
                <div className="testimonial-avatar" style={{ backgroundColor: getAvatarColor(index) }}>
                  {review.initials}
                </div>
                <div className="testimonial-info">
                  <h4 className="testimonial-name">{review.name}</h4>
                  <p className="testimonial-city">{review.city}</p>
                </div>
              </div>
              <div className="testimonial-rating">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="fas fa-star rating-star"></i>
                ))}
              </div>
              <p className="testimonial-text">"{review.text}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function getAvatarColor(index) {
  const colors = ['#0207af', '#28a745', '#e83e8c', '#fd7e14'];
  return colors[index % colors.length];
}
